export function getSentry() {
  return import(/* webpackChunkName: "sentry" */ '@sentry/browser');
}

export function initSentry(key, orgId?) {
  return getSentry().then((Sentry) => {
    // todo set org and user info (tracking token? customer id?)
    if (!Sentry.getCurrentHub().getClient()) {
      Sentry.init({
        dsn: `https://${key}@o38471.ingest.sentry.io/6150287`, // 6150287 is project ID. not sure what o38471 is
        environment: process.env.SENTRY_ENV,
        release: process.env.VERSION,
        initialScope: {
          tags: { orgId },
        },
      });
    }
    return Sentry;
  });
}

export function captureException(error) {
  return getSentry().then((Sentry) => {
    return Sentry.captureException(error);
  });
}
